import { Box } from "@mui/material";
import { useRef } from "react";
import { useMobileMenu } from "./MobileMenuProvider";

export default function MobileMenuIcon({
    sx = {},
}) {
    const { setOpenInternal: setOpen, open, } = useMobileMenu();
    const clickLocked = useRef(false);

    const handleClick = () => {
        if (clickLocked.current) return;

        clickLocked.current = true;
        const newOpen = !open;
        setOpen(newOpen);

        setTimeout(() => {
            clickLocked.current = false;
        }, 200);
    };

    const lineStyle = {
        width: "100%",
        height: "2.5px",
        bgcolor: "#4534C2",
        borderRadius: "3px",
    };

    return (
        <Box
            sx={{
                width: "42px",
                height: "42px",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                "&:hover": {
                    cursor: "pointer",
                },
                ...sx,
            }}
            onClick={handleClick}
        >
            <Box
                sx={{
                    width: "24px",
                    height: open ? "24px" : "16px",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "flex-end",
                }}
            >
                <Box
                    sx={{
                        ...lineStyle,
                        transition: "transform .3s ease-in-out",
                        position: "absolute",
                        top: 0,

                        transform: open
                            ? "rotate(-45deg) translate(-6px,9px);"
                            : "rotate(0deg)",
                    }}
                ></Box>
                <Box
                    sx={{
                        ...lineStyle,
                        width: "60%",
                        transition: "opacity .3s",
                        opacity: open ? 0 : 1,
                    }}
                ></Box>
                <Box
                    sx={{
                        ...lineStyle,
                        position: "absolute",
                        bottom: 0,
                        width: open ? "100%" : "60%",
                        transition: "transform .3s ease-in-out",
                        transform: open
                            ? "rotate(45deg) translate(-6px,-9px);"
                            : "rotate(0deg)",
                    }}
                />
            </Box>
        </Box>
    );
}
